import React, {useMemo, useContext} from 'react';
import {ApiContext} from "../../../../api/Api";
import ReactTable from "react-table";
import useTideTable from "../../../../hooks/table/useTideTable";
import Button from "../../../../elements/CustomButton/CustomButton";
import FileSaver from "file-saver";
import {listSGroups, orozcoPaymentsListTable} from '../../../../utils/modelUtils/orozco/orozcoPaymentUtils';

const PaymentsList = () => {

    const api = useContext(ApiContext);

    const requestFilters = useMemo(() => ({
        sGroups: listSGroups,
        'order[createdDate]': 'DESC'
    }), []);

    const table = useTideTable({
        entity: 'orozcoPayments',
        columns: orozcoPaymentsListTable,
        requestFilters
    });

    const apiFilters = table.lastUsedApiOptions?.filters||{};

    const downloadPayments = async () => {
        const downloadUrl = api.orozcoPayments.exportUrl({
            ...apiFilters,
            pagination: false
        });

        try {
            const response = await fetch(downloadUrl, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Authorization': 'Bearer '+api.token
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const blob = await response.blob();
            FileSaver.saveAs(blob, 'OrozcoPayments.xlsx');
        } catch (error) {
            console.error('Error exporting Orozco payments:', error);
        }
    };

    return (
        <div className='PaymentsList container-fluid'>
            <ReactTable
                {...table.tableProps}
            />

            <Button onClick={downloadPayments}>Exportar a Excel</Button>
        </div>
    );
};

export default PaymentsList;
